/**
 * Makes every "Créer son livre" / "Personnaliser son livre" / "Essayer avec sa
 * photo" button actually land on the photo upload.
 *
 * Two separate problems, both invisible from the markup:
 *
 * 1. SAME-PAGE clicks. The buttons are plain <a href="#personnaliser"> and the
 *    target element exists, so on an ordinary page they would work. This theme
 *    opts into cross-document view transitions and loads view-transitions.js,
 *    which intercepts link clicks to animate navigation and swallows same-page
 *    hash links. Listening in the CAPTURE phase takes the click back before any
 *    theme script sees it.
 *
 * 2. CROSS-PAGE arrivals. Coming from the homepage to
 *    /products/...#personnaliser, the browser scrolls on load - but the section
 *    is below lazily-hydrated sections whose height changes after that scroll,
 *    so it lands in the wrong place or not at all. Re-scrolling after load, and
 *    once more a beat later, puts it where the customer expects.
 */
(function () {
  var HASH = '#personnaliser';

  function target() {
    return document.getElementById('personnaliser');
  }

  function goTo(el, smooth) {
    el.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' });
  }

  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      var link = t && t.closest ? t.closest('a[href$="' + HASH + '"]') : null;
      if (!link) return;
      // Only hijack links that stay on this page; a link to another product must
      // navigate normally.
      var here = link.getAttribute('href') === HASH;
      var el = target();
      if (!here || !el) return;
      e.preventDefault();
      e.stopPropagation();
      goTo(el, true);
      var file = el.querySelector("input[type='file']");
      if (file) {
        try { file.focus({ preventScroll: true }); } catch (err) { /* older browsers */ }
      }
    },
    true
  );

  if (location.hash === HASH) {
    var settle = function () {
      var el = target();
      if (el) goTo(el, false);
    };
    window.addEventListener('load', settle);
    // Sections above this one hydrate and change height after load; one more pass
    // lands it correctly rather than a few hundred pixels off.
    window.setTimeout(settle, 600);
  }
})();
